// extracted by mini-css-extract-plugin
export default {"page":"PricingPage_page__yIYJX"};